<!-- eslint-disable-next-line  @angular-eslint/template/no-inline-styles -->
<div
	class="toast-container position-fixed message-toast-container-{{ placement }} message-z-index"
	[ngStyle]="customStyle"
>
	<ng-container #toastMessage></ng-container>
</div>
